import { CURRENCIES, CurrencyCodes } from "@fena/toolkit-types";
import { FlagIconCode } from "react-flag-kit";
import { SearchFieldType } from "../components/advanced-search/AdvancedSearch.interface";

export interface CurrencyItem {
  label: string;
  currencyCode: CurrencyCodes;
  countryCode: string | FlagIconCode;
  symbol: string;
  isDefaultCurrency?: boolean;
}

export const getCurrencyCodeByCountryCode = (
  countryCode?: string // like "GB"
): CurrencyCodes => {
  const entry = Object.entries(CURRENCIES).find(
    ([, data]) => data.countryCode.toUpperCase() === countryCode?.toUpperCase()
  );
  return (entry?.[0] ?? CurrencyCodes.POUND_STERLING) as CurrencyCodes;
};

export const currencyDropdownItems: CurrencyItem[] = Object.keys(
  CURRENCIES
).map((key) => {
  const currency = CURRENCIES[key as CurrencyCodes];
  return {
    label: currency.name,
    currencyCode: key as CurrencyCodes,
    countryCode: currency.countryCode,
    symbol: currency.symbol,
  };
});

export const defaultCurrencyItemForDropdown = {
  label: "Pound Sterling",
  symbol: "£",
  currencyCode: CurrencyCodes.POUND_STERLING,
  countryCode: "GB",
};

export const firstCurrencyItemAdvancedSearch = {
  label: "All currencies",
  countryCode: "",
  currencyCode: "" as CurrencyCodes,
  symbol: "",
};

export const currencyConfig = {
  type: SearchFieldType.CURRENCY_DROPDOWN,
  label: "Currency",
  key: "currency",
};
